const SEGMENTS = 128;
const FACE_CLEARANCE = 0.01;
export function nearestTrackingContour(contours, target) {
    const distance = (contour) => Math.hypot(...contour.position.map((value, axis) => value - target[axis]));
    return contours.reduce((nearest, contour) => !nearest || distance(contour) < distance(nearest) ? contour : nearest, undefined);
}
export function contourLines(contour) {
    if ('points' in contour)
        return [[...contour.points]];
    if ('sphereRadius' in contour)
        return [Array.from({ length: SEGMENTS + 1 }, (_, index) => {
                const angle = index * Math.PI * 2 / SEGMENTS;
                return [Math.cos(angle) * contour.sphereRadius, Math.sin(angle) * contour.sphereRadius, 0];
            })];
    const start = contour.startAngle ?? 0, end = contour.endAngle ?? Math.PI * 2;
    const partial = contour.startAngle !== undefined;
    const segments = Math.max(1, Math.ceil(SEGMENTS * (end - start) / (Math.PI * 2)));
    const point = (radius, height, angle) => [Math.sin(angle) * radius, height, Math.cos(angle) * radius];
    const arc = (radius, height) => Array.from({ length: segments + 1 }, (_, index) => point(radius, height, start + (end - start) * index / segments));
    return [1, -1].flatMap(side => {
        const innerHeight = side * (contour.innerHalfHeight + FACE_CLEARANCE);
        const outerHeight = side * (contour.outerHalfHeight + FACE_CLEARANCE);
        return [
            arc(contour.outerRadius, outerHeight),
            ...(contour.innerRadius > 1e-6 ? [arc(contour.innerRadius, innerHeight)] : []),
            ...(partial ? [start, end].map(angle => [
                point(contour.innerRadius, innerHeight, angle), point(contour.outerRadius, outerHeight, angle),
            ]) : []),
        ];
    });
}
